import { CuisineCategories, CuisineTypes, RestaurantTypes } from '../../../../../modals/company/Constants';
import { Step } from '../../../../../modals/company/add-company-modal';
import { LeadSources, PosSystems } from '../../../../../modals/company/add-company-modal/BusinessDetails';
import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Înregistrare restaurant',
  description: 'Pasul {{activeStep}} din {{totalSteps}}',
  steps: {
    [Step.BasicInfo]: 'Informații de bază',
    [Step.BusinessDetails]: 'Detalii afacere',
  },
  form: {
    name: {
      label: 'Numele restaurantului',
      placeholder: 'Introduceți numele restaurantului',
    },
    timezone: {
      label: 'Fus orar',
      placeholder: 'Caută un oraș sau fus orar',
      inference_failed: 'Nu am putut determina fusul orar din această adresă — vă rugăm să îl selectați.',
    },
    google_place: {
      label: 'Locație Google selectată: {{name}}',
    },
    is_franchise: {
      label: 'Restaurantul face parte dintr-un brand',
    },
    sync_lieferando_brand: {
      label: 'Preluați detalii brand (logo, culoare principală) din Lieferando',
    },
    import_menu: {
      label: 'Importați meniu',
    },
    lieferando_url: {
      label: 'URL Lieferando',
      placeholder: 'URL-ul restaurantului în Lieferando',
    },
    other_platforms: {
      label: 'Platforme de livrare actuale',
      description: 'Selectați toate platformele unde sunteți listați în prezent',
    },
    pos_system: {
      label: 'Sistem POS actual',
      placeholder: 'Selectați sistemul POS',
      options: {
        [PosSystems.Other]: 'Altul',
      },
    },
    delivery_mode: {
      label: 'Mod de livrare',
      placeholder: 'Selectați modul de livrare',
      options: {
        [DeliveryMode.Internal]: 'Intern (proprii șoferi)',
        [DeliveryMode.External]: 'Extern (terță parte)',
      },
    },
    monthly_sales_other_platforms: {
      label: 'Vânzări lunare livrare',
      description: 'Vânzări totale pe toate platformele de livrare',
      placeholder: 'Selectați intervalul de vânzări',
      options: {
        other: 'Altul',
      },
      other: {
        placeholder: 'Introduceți suma vânzărilor',
      },
    },
    lead_source: {
      label: 'Sursă lead',
      description: 'Cum ați aflat despre noi?',
      options: {
        [LeadSources.SDR]: {
          title: 'SDR',
          description: 'Prospectare prin reprezentant de vânzări',
        },
        [LeadSources.Inbound]: {
          title: 'Inbound',
          description: 'A ajuns prin site web sau marketing',
        },
        [LeadSources.Referral]: {
          title: 'Recomandare - Restaurant existent',
          description: 'Recomandat de un restaurant partener',
        },
        [LeadSources.SelfGeneratedCold]: {
          title: 'Generat intern - Cold',
          description: 'Găsit prin prospectare directă',
        },
        [LeadSources.SelfGeneratedReferral]: {
          title: 'Generat intern - Recomandare',
          description: 'Rețea sau contact personal',
        },
        [LeadSources.Tipster]: {
          title: 'Tipster',
          description: 'Foodamigos plătește persoanei/companiei X un comision pentru recomandare',
        },
      },
    },
    sdr: {
      description: 'Selectați SDR-ul responsabil pentru acest lead',
    },
    has_instagram_profile: {
      label: 'Profil Instagram',
      description: 'Restaurantul dvs. are un profil Instagram?',
      options: {
        true: 'Da',
        false: 'Nu',
      },
    },
  },
  buttons: {
    back: 'Înapoi',
    next: 'Următor',
    complete_registration: 'Finalizați înregistrarea',
  },
  basic_information: {
    title: 'Informații de bază',
    description: 'Introduceți detaliile de bază și informațiile de contact ale restaurantului',
  },
  additional_options: {
    title: 'Opțiuni suplimentare',
    description: 'Configurați setări suplimentare pentru acest restaurant',
  },
  restaurant_type: {
    title: 'Tip restaurant și model de servicii',
    description: 'Alegeți formatul care descrie cel mai bine stilul de servicii al restaurantului',
  },
  cuisine_type: {
    title: 'Categorii alimentare și tipuri de bucătărie',
    description: 'Selectați toate categoriile și tipurile de bucătărie aplicabile restaurantului',
    placeholder: 'Căutați tipuri de bucătărie',
  },
  business_details: {
    title: 'Detalii afacere',
    description: 'Ajutați-ne să înțelegem operațiunile dvs. actuale',
  },
  restaurant_types: {
    [RestaurantTypes.FullServiceRestaurant]: {
      title: 'Restaurant cu servicii complete',
      description: 'Servire la masă cu ospătari',
    },
    [RestaurantTypes.FastCasual]: {
      title: 'Fast Casual',
      description: 'Comandă la tejghea/aplicație, calitate superioară față de QSR, locuri opționale',
    },
    [RestaurantTypes.QuickServiceTakeaway]: {
      title: 'Serviciu rapid (QSR) / Takeaway',
      description: 'Serviciu la tejghea orientat spre viteză; preponderent takeaway',
    },
    [RestaurantTypes.CafeAndBakery]: {
      title: 'Cafenea și Patiserie',
      description: 'Cafea, produse de patiserie, mese ușoare, mic dejun/brunch',
    },
    [RestaurantTypes.DessertAndIceCream]: {
      title: 'Deserturi și Înghețată',
      description: 'Concepte axate pe dulciuri',
    },
    [RestaurantTypes.DrinksAndBar]: {
      title: 'Băuturi și Bar',
      description: 'Localuri axate pe băuturi; mâncare opțională; livrarea alcoolului supusă regulilor locale',
    },
    [RestaurantTypes.DeliveryOnlyOrGhostKitchen]: {
      title: 'Doar livrare / Bucătărie fantomă',
      description: 'Fără vitrină; branduri virtuale și bucătării cloud',
    },
  },
  cuisine_types: {
    [CuisineTypes.Pizza]: 'Pizza',
    [CuisineTypes.Burgers]: 'Burgeri',
    [CuisineTypes.ChickenFried]: 'Pui prăjit',
    [CuisineTypes.Wings]: 'Aripioare',
    [CuisineTypes.KebabDoner]: 'Kebab/Döner',
    [CuisineTypes.Sandwiches]: 'Sandvișuri',
    [CuisineTypes.Wraps]: 'Wraps',
    [CuisineTypes.Salads]: 'Salate',
    [CuisineTypes.Healthy]: 'Sănătos',
    [CuisineTypes.Bowls]: 'Boluri',
    [CuisineTypes.Vegan]: 'Vegan',
    [CuisineTypes.Vegetarian]: 'Vegetarian',
    [CuisineTypes.GlutenFree]: 'Fără gluten',
    [CuisineTypes.Halal]: 'Halal',

    [CuisineTypes.Sushi]: 'Sushi',
    [CuisineTypes.Japanese]: 'Japonez',
    [CuisineTypes.Ramen]: 'Ramen',
    [CuisineTypes.UdonSoba]: 'Udon/Soba',
    [CuisineTypes.Korean]: 'Coreean',
    [CuisineTypes.KoreanFriedChicken]: 'Pui prăjit coreean',
    [CuisineTypes.Chinese]: 'Chinezesc',
    [CuisineTypes.Sichuan]: 'Sichuan',
    [CuisineTypes.CantoneseDimSum]: 'Cantoneză/Dim Sum',
    [CuisineTypes.Thai]: 'Thai',
    [CuisineTypes.Vietnamese]: 'Vietnamez',
    [CuisineTypes.Malaysian]: 'Malaiez',
    [CuisineTypes.Indonesian]: 'Indonezian',
    [CuisineTypes.Filipino]: 'Filipinez',
    [CuisineTypes.Poke]: 'Poke',
    [CuisineTypes.HotPot]: 'Hot Pot',
    [CuisineTypes.DumplingsGyozaBao]: 'Găluște/Gyoza/Bao',

    [CuisineTypes.Indian]: 'Indian',
    [CuisineTypes.Biryani]: 'Biryani',
    [CuisineTypes.Pakistani]: 'Pakistani',
    [CuisineTypes.SriLankan]: 'Sri Lankan',
    [CuisineTypes.Nepalese]: 'Nepalez',

    [CuisineTypes.Turkish]: 'Turcesc',
    [CuisineTypes.Lebanese]: 'Libanez',
    [CuisineTypes.Syrian]: 'Sirian',
    [CuisineTypes.Israeli]: 'Israelian',
    [CuisineTypes.Egyptian]: 'Egiptean',
    [CuisineTypes.PersianIranian]: 'Persan/Iranian',
    [CuisineTypes.Iraqi]: 'Irakian',
    [CuisineTypes.Afghan]: 'Afgan',
    [CuisineTypes.ShawarmaFalafel]: 'Shawarma/Falafel',
    [CuisineTypes.MezzeGrill]: 'Mezze/Grătar',
    [CuisineTypes.Greek]: 'Grecesc',
    [CuisineTypes.Mediterranean]: 'Mediteranean',

    [CuisineTypes.Italian]: 'Italian',
    [CuisineTypes.Pasta]: 'Paste',
    [CuisineTypes.French]: 'Francez',
    [CuisineTypes.SpanishTapas]: 'Spaniol/Tapas',
    [CuisineTypes.Portuguese]: 'Portughez',
    [CuisineTypes.German]: 'German',
    [CuisineTypes.Austrian]: 'Austriac',
    [CuisineTypes.Balkan]: 'Balcanic',
    [CuisineTypes.Hungarian]: 'Maghiar',
    [CuisineTypes.Polish]: 'Polonez',
    [CuisineTypes.Czech]: 'Ceh',
    [CuisineTypes.Georgian]: 'Georgian',

    [CuisineTypes.Mexican]: 'Mexican',
    [CuisineTypes.TexMex]: 'Tex-Mex',
    [CuisineTypes.Peruvian]: 'Peruvian',
    [CuisineTypes.Brazilian]: 'Brazilian',
    [CuisineTypes.Argentinian]: 'Argentinian',
    [CuisineTypes.Caribbean]: 'Caraibic',
    [CuisineTypes.BBQAmerican]: 'BBQ/American',
    [CuisineTypes.Steakhouse]: 'Steakhouse',
    [CuisineTypes.AmericanGeneral]: 'American (General)',
    [CuisineTypes.HotDogs]: 'Hot Dogs',

    [CuisineTypes.Seafood]: 'Fructe de mare',
    [CuisineTypes.FishAndChips]: 'Fish and Chips',
    [CuisineTypes.SteamedFish]: 'Pește la abur',

    [CuisineTypes.BreakfastBrunch]: 'Mic dejun/Brunch',
    [CuisineTypes.Bagels]: 'Bagels',
    [CuisineTypes.Bakery]: 'Brutărie',
    [CuisineTypes.PastryDessert]: 'Patiserie/Desert',
    [CuisineTypes.WafflesCrepes]: 'Vafe/Clătite',
    [CuisineTypes.IceCreamGelato]: 'Înghețată/Gelato',
    [CuisineTypes.Donuts]: 'Gogoși',
    [CuisineTypes.Cakes]: 'Torturi',

    [CuisineTypes.CoffeeCafe]: 'Cafea/Cafenea',
    [CuisineTypes.BubbleTea]: 'Bubble Tea',
    [CuisineTypes.JuiceSmoothies]: 'Sucuri/Smoothies',
    [CuisineTypes.Milkshakes]: 'Milkshake-uri',
    [CuisineTypes.BarPub]: 'Bar/Pub',
    [CuisineTypes.WineBar]: 'Wine Bar',
    [CuisineTypes.Cocktails]: 'Cocktailuri',

    [CuisineTypes.TapasMezeSmallPlates]: 'Tapas/Mezze/Porții mici',
    [CuisineTypes.Noodles]: 'Tăiței',
    [CuisineTypes.Soup]: 'Supă',
    [CuisineTypes.Schnitzel]: 'Șnițel',
    [CuisineTypes.SoulFood]: 'Soul Food',
    [CuisineTypes.ComfortFood]: 'Comfort Food',
    [CuisineTypes.StreetFood]: 'Street Food',
    [CuisineTypes.OrganicBio]: 'Organic/Bio',
    [CuisineTypes.KidsMenu]: 'Meniu Copii',
  },
  cuisine_categories: {
    [CuisineCategories.TopGeneral]: 'Top/General',
    [CuisineCategories.AsianPacific]: 'Asiatic/Pacific',
    [CuisineCategories.SouthAsian]: 'Asia de Sud',
    [CuisineCategories.MiddleEastMediterranean]: 'Orient Mijlociu/Mediteranean',
    [CuisineCategories.Europe]: 'Europa',
    [CuisineCategories.Americas]: 'Americi',
    [CuisineCategories.SeafoodSpecialty]: 'Specialitate fructe de mare',
    [CuisineCategories.BreakfastBakerySweets]: 'Brutărie mic dejun/Dulciuri',
    [CuisineCategories.BeverageLed]: 'Axat pe băuturi',
    [CuisineCategories.OtherConcepts]: 'Alte concepte',
  },
};
